export default __webpack_public_path__ + "static/media/actividad-16.38ae78f3.mp3";